import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/authentication/auth.service';
// import { environment } from '@environments/environment';
import { UiService } from 'app/core/services/ui.service';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MessageBox } from '@components/message-box/message-box.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  styles: [`
  >>> app-login {
    height: 100%;
    display: flex;
  }
`]
})
export class LoginComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  loginForm!: FormGroup;
  forgetPasswordForm!: FormGroup;

  isLoading: boolean = false;

  hide = true;
  environmentName = this.environment.application;

  constructor(
    private authSrv: AuthService,
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private translateService: TranslateService,
    public envConfigurationService: EnvConfigurationService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  private initForm(): void {
    this.loginForm = this.fb.group({
      username: new FormControl(null, [Validators.required]),
      password: [null, Validators.required]
    });

    this.forgetPasswordForm = this.fb.group({
      username: new FormControl(null, [Validators.required]),
      // societyEmail: new FormControl(null, [Validators.required, Validators.email])
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.authSrv.login(this.loginForm.value).subscribe((success) => {
        this.router.navigate(['/']);
      }, (error) => {
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      }
      );
    }
  }

  onSubmitForgetPassword(): void {
    if (this.forgetPasswordForm.valid) {
      this.isLoading = true;
      this.authSrv.forgetPassword(this.forgetPasswordForm.controls.username.value).subscribe((success) => {
        // this.router.navigate(['/']);

        const messageBoxParameter = new MessageBoxParameter();

        messageBoxParameter.title = this.translateService.instant('login.reset-password-title');
        messageBoxParameter.message = this.translateService.instant('login.reset-password-content');
        messageBoxParameter.dialog = this.dialog;
        messageBoxParameter.buttons = ['ok'];
        messageBoxParameter.width = "400px";
        MessageBox.show(messageBoxParameter).subscribe(mbResult => { });

      }, (error) => {
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      }
      );
    }
  }

}
